import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, profile, assessments, isBootstrapping } = useAuth();
  const location = useLocation();

  // while auth is initializing, don't redirect — let bootstrap finish
  if (isBootstrapping) return null;

  // not authenticated => go to signin
  if (!user) return <Navigate to="/signin" replace state={{ from: location }} />;

  // Consider localStorage flags as a fallback in case context isn't populated yet.
  const lsHasProfile = typeof window !== 'undefined' && localStorage.getItem('HAS_PROFILE') === 'true';
  const lsHasAssessment = typeof window !== 'undefined' && localStorage.getItem('HAS_ASSESSMENT') === 'true';

  const hasProfile = Boolean(profile) || lsHasProfile;
  // Determine whether there's at least one meaningful/completed assessment.
  const assessmentsArr = Array.isArray(assessments) ? assessments : [];
  const hasMeaningfulAssessment = assessmentsArr.some((as) => {
    if (!as || typeof as !== 'object') return false;
    if (typeof as.score === 'number' && !Number.isNaN(as.score)) return true;
    if (as.fullName && String(as.fullName).trim().length > 0) return true;
    if ((as.weightKg || as.weight || as.heightCm || as.height) && (as.weightKg > 0 || as.weight > 0 || as.heightCm > 0 || as.height > 0)) return true;
    const keys = Object.keys(as || {});
    return keys.length >= 3;
  });
  const hasAssessment = hasMeaningfulAssessment || lsHasAssessment;

  // Setup pages that are allowed before setup is complete.
  const allowPaths = ['/health-assessment', '/profile-setup'];
  // If setup incomplete and user not on allowPaths, send them to assessment.
  if (!(hasProfile && hasAssessment) && !allowPaths.includes(location.pathname)) {
    return <Navigate to="/health-assessment" replace />;
  }

  // Users should be able to revisit health assessment to edit their record.
  // Only block profile setup once onboarding is complete.
  if (hasProfile && hasAssessment && location.pathname === '/profile-setup') {
    return <Navigate to="/home" replace />;
  }

  return children;
}
